import { User, UserManager } from 'oidc-react';
import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'oidc-react/build/src/AuthContextInterface';


export const userManager: UserManager = new UserManager({
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY_URL || '',
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
  redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || '',
  post_logout_redirect_uri: process.env.REACT_APP_KEYCLOAK_POST_LOGOUT_REDIRECT_URI || '',
  // automaticSilentRenew: true, // default
  // response_type: 'code', // default
  scope: 'openid profile email offline_access', // Include offline_access if you need refresh tokens
  userStore: new WebStorageStateStore({ store: window.localStorage }), // Use localStorage for persistence
})

export const oidcConfig: AuthProviderProps = {
  onSignIn: (userData: User | null): void => {
    console.log('[OIDC]: onSignIn');
    window.history.replaceState(userData, '', '/');
  },
  onSignOut: (): void => {
    console.log('[OIDC]: onSignOut');
  },
  autoSignIn: false,
  userManager
};
